export default __webpack_public_path__ + "static/media/langActive.d3618410.svg";